/** --------------------------------------------------------------------------------------------------------------------
 * responsive view Column, try to be like Bootstrap
 *
 * @Dpendences => 'classname' :: install with 'npm install classnames' || 'yarn add classnames'
 */

import React      from 'react'     ;
import classNames from 'classnames';

import './index.css';

type Sizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type Props = {
  children: React.ReactNode;

  id       ?: string;
  style    ?: React.CSSProperties;
  className?: string;

  large     ?: Sizes; // Maps to `responsive-view-column-lg-*`
  small     ?: Sizes; // Maps to `responsive-view-column-sm-*`
  medium    ?: Sizes; // Maps to `responsive-view-column-md-*`
  extraSmall?: Sizes; // Maps to `responsive-view-column-xs-*`
  extraLarge?: Sizes; // Maps to `responsive-view-column-xl-*`
};

const Column = (props: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const columnClasses = classNames(
    {
      [`responsive-view-column-lg-${props?.large}`     ]: props?.large     ,
      [`responsive-view-column-sm-${props?.small}`     ]: props?.small     ,
      [`responsive-view-column-md-${props?.medium}`    ]: props?.medium    ,
      [`responsive-view-column-xs-${props?.extraSmall}`]: props?.extraSmall,
      [`responsive-view-column-xl-${props?.extraLarge}`]: props?.extraLarge,
    },
    props?.className
  );

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================


  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id={props?.id} className={columnClasses} style={props.style}>
      {props?.children}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Column;
